/* eslint-disable @typescript-eslint/no-unused-vars */
import { Grid, MenuItem, Tab } from '@material-ui/core';
import {
  ChevronRight, Description as DescriptionIcon, Send, Search, Group, CheckCircle, Cancel, TuneRounded as Tune,
  GetApp,
} from '@material-ui/icons';
import { exportClassroomsStatement, getInfosDashboard } from '@webapps/business';
import SchoolIcon from '@material-ui/icons/SchoolRounded';
import {
  getClasses,
  getDegree,
  getFormationsMap,
  getTrainingType,
} from '@webapps/business';
import {
  Button,
  FormikTextField50,
  TextField,
  useAuth,
  useQuery,
  useRouter,
  ModalSideBar,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';

import Team from 'components/Icons/Team';
import Modal, { default as ModalStep } from 'components/Modal';
import { ROUTES_PATH } from 'config/constants';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import InviteStudents from './Components/inviteStudent';
import NewClasses from './Components/NewClasses';
import Result from './Components/Result';
import { useFormik } from 'formik';
import * as yup from 'yup';
import FiltersClasses from './Components/FiltersClasses';
import KPIClasses from './Components/KPIClasses';
import AbsenceDeclarationModal from 'components/AbsenceDeclarationModal';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import ActivityStatement from './Components/ActivityStatement';
import ProfilSidebar from 'components/ProfilSidebar';
import ProfilName from 'components/ProfilSidebar/Components/ProfilName';
import ExportModal from './Components/ExportModal';

const defaultInitialValues = {
  keyword: '',
  partners: [],
  cities: '',
  degrees: [],
  domains: [],
  goals: [],
  jobDomain: [],
  jobs: [],
  desiredContractLength: '',
  certifiedProfile: 'all',
  training: 'all',
  trainingType: 'all',
  degree: 'all',
};

const filterSchema = yup?.object().shape({
  keyword: yup?.string(),
  partners: yup?.array(),
  cities: yup?.string(),
  degrees: yup?.array(),
  goals: yup?.array(),
  jobDomain: yup?.array(),
  jobs: yup?.array(),
  desiredContractLength: yup?.string().nullable(true),
  domains: yup?.array(),
  certifiedProfile: yup?.string(),
  training: yup?.string(),
  trainingType: yup?.string(),
  degree: yup?.string(),
});

const ClassesSchool = () => {

  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  const { idUser } = useAuth();
  const intl = useIntl();
  const [openCreateClasses, setOpenCreateClasses] = useState(false);
  const [absenceModalOpen, setAbsenceModalOpen] = useState(false);
  const [openInviteStudents, setOpenInviteStudents] = useState(false);
  const [openSetPlanning, setOpenSetPlanning] = useState(false);
  const location = useLocation();
  const [keyword, setKeyword] = useState('');
  const [training, setTraining] = useState(location?.state?.trainingId || '');
  const [degree, setDegree] = useState('');
  const [trainingType, setTrainingType] = useState('');
  const [filterCVOpened, setFilterCVOpened] = useState(false);
  const [tabValue, setTabValue] = useState('1');
  const [idClassCreated, setIdClassCreated] = useState(null);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [openStatementPeriodModal, setOpenStatementPeriodModal] = useState("");

  const { push } = useRouter();

  // FRONT END RESTRICTIONS => Redirect to dashboard if free Account
  const { checkPermissions, isPremium } = useAuth();

  const { data: dashboardInfo = {}, refetch: refetchDashboardInfo } = useQuery(getInfosDashboard, {
    key: 'infoDashboardTutorial',
    variables: { id: idUser },
  });

  // alert("__")
  const kpiData = [
    { label: 'En entreprise', value: dashboardInfo?.studentStats?.workStudyStudents, icon: CheckCircle },
    { label: 'Étudiants sans entreprise', value: dashboardInfo?.studentStats?.totalStudents - dashboardInfo?.studentStats?.workStudyStudents, icon: Cancel },
    { label: 'Contrats à envoyer', value: dashboardInfo?.contractStats?.contractsToSend, icon: DescriptionIcon },
    { label: 'Contrats en attentes', value: dashboardInfo?.contractStats?.contractsToSign, icon: DescriptionIcon },
  ];


  useEffect(() => {
    if (isPremium !== null) {
      checkPermissions();
    }
  }, [isPremium]);

  const handleOpenCreateClasses = () => {
    setOpenCreateClasses(true);
  };

  const handleCloseCreateClasses = () => {
    setOpenCreateClasses(false);
  };

  const handleOpenInviteStudents = () => {
    setOpenInviteStudents(true);
  };

  const handleCloseInviteStudents = () => {
    setOpenInviteStudents(false);
  };

  const handleOpenSetPlanning = () => {
    setOpenSetPlanning(true);
  };

  const handleCloseSetPlanning = () => {
    setOpenSetPlanning(false);
  };

  const handleFilterCVClose = () => {
    setFilterCVOpened(false);
  };

  const handleFilterCVOpen = () => {
    setFilterCVOpened(true);
  };

  const handleSetIdClassCreated = (id) => {
    setIdClassCreated(id);
  };

  const handleTabChange = (event, newValue) => setTabValue(newValue);

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(window.innerWidth > 1770 ? 8 : window.innerWidth > 1024 ? 6 : 4);
  const [item, setItem] = useState("");
  const [classroomId, setClassroomId] = useState(0);
  const [currentRefetchAbsenceHours, setCurrentRefetchAbsenceHours] = useState(null);
  const [viewProfil, setViewProfil] = useState(false);

  const viewAbsence = (item, classroomId) => {

    setItem(item);
    setClassroomId(classroomId);
    // setCurrentRefetchAbsenceHours(() => refetchAbsenceHours); // Passer la fonction
    setAbsenceModalOpen(true);
  };

  const handleOpenViewProfil = () => {
    setViewProfil(true);
  };

  const viewCV = (item, classroomId) => {
    setItem(item);
    setClassroomId(classroomId);
    handleOpenViewProfil();
  };

  const handleCloseViewProfil = () => {
    setViewProfil(false);
  };

  const handleOpenExportModal = (id) => {
    setClassroomId(id)
    setIsExportModalOpen(true)
  }

  const handleCloseExportModal = () => {
    setClassroomId(0)
    setIsExportModalOpen(false)
  }

  const { data: { content: allClasses = [], totalElements } = {}, isLoading, refetch } =
    useQuery(getClasses, {
      key: ['classes', page + keyword + training + trainingType + degree],
      variables: {
        keyword,
        training,
        trainingType,
        degree,
        id: idUser,
        page: page - 1,
        size,
      },
      keepPreviousData: true,
      staleTime: 5000,
    });

  // Log des valeurs utilisées dans useQuery après l'initialisation

  const formik = useFormik({
    initialValues: defaultInitialValues,
    validationSchema: filterSchema,
    onSubmit: ({
      training,
      trainingType,
      degree,
    }) => {
      // push

      setTraining(training === 'all' ? '' : training);
      setTrainingType(trainingType === 'all' ? '' : trainingType);
      setDegree(degree === 'all' ? '' : degree);
      setPage(1);
      setFilterCVOpened(false);

    },
  });

  useEffect(() => {
    if (location?.state?.openInviteStudents) {
      if (totalElements > 0) {
        handleOpenInviteStudents();
        location.state = null;
      }
    }
  }, [location, totalElements]);

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const searchKeyword = (e) => {
    setKeyword(e.target.value);
    setPage(1);
  };

  const goToListInviteStudent = () => {
    push(ROUTES_PATH.SCHOOL_INVITE_STUDENT);
  };

  const goToStudentClassHistorique = () => {
    push(ROUTES_PATH.STUDENT_CLASS_HISTORIQUE);
  };

  if (!isPremium) {
    return <div></div>;
  }


  return (
    <div className={classes.container}>
      <KPIClasses data={kpiData} />

      <TabContext value={tabValue}>
        <TabList
          className={css({
            paddingLeft: spacing(0),
            width: '100%',
          })}
          // orientation={}
          variant={window.innerWidth < 768 ? 'fullWidth' : 'standard'}
          indicatorColor="default"
          onChange={handleTabChange}
        >
          <Tab
            classes={{
              root: css({
                border: '1px solid #C0D9FF',
                borderBottom: 0,
                borderTopLeftRadius: 5,
                opacity: 1,
                borderTopLeftRadius: 5,
                opacity: 1,
                minWidth: '12vw',
                borderTopRightRadius: 5,
                background: tabValue === '1' ? 'white' : '#F3F7FF',
                color: tabValue === '1' ? '#152652' : '#5A6DA1',
                fontWeight: tabValue === '1' ? 600 : 400,
                '@media screen and (max-width: 768px)': {
                  width: '100%',
                },
              }),
            }}
            className={global.mainTitle}
            label={`Classes (${totalElements || 0})`} value="1" />
          <Tab
            classes={{
              root: css({
                border: '1px solid #C0D9FF',
                borderBottom: 0,
                borderTopLeftRadius: 5,
                opacity: 1,
                borderTopLeftRadius: 5,
                opacity: 1,
                minWidth: '12vw',
                borderTopRightRadius: 5,
                background: tabValue === '2' ? 'white' : '#F3F7FF',
                color: tabValue === '2' ? '#152652' : '#5A6DA1',
                fontWeight: tabValue === '2' ? 600 : 400,
                '@media screen and (max-width: 768px)': {
                  width: '100%',
                },
              }),
            }}
            className={global.mainTitle}
            label={`Tous les étudiants (${dashboardInfo?.studentStats?.totalStudents || 0})`} value="2" />
        </TabList>



        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            '@media screen and (max-width: 768px)': {
              height: '100%',
            },
          })}
        >
          <TabPanel value="1" index={1}
            className={css({
              background: 'white',
              borderRadius: '0 10px 10px 10px',
              padding: spacing(2.5),
            })}
          >
            <div className={classes.containerSearch}>
              <div
                className={css({
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  width: '100%',
                  gap: spacing(2), // espace entre les éléments, ajustable selon le design
                  '@media (max-width: 768px)': {
                    flexDirection: 'column', // empiler en colonne pour petits écrans
                    width: '100%',
                  },
                })}
              >
                <div
                  className={
                    css({
                      display: 'flex',
                      gap: spacing(2),
                      flexWrap: 'wrap',
                      '@media (max-width:768px)': {
                        width: '100%',
                        backgroundColor: 'red'
                      },
                      '@media (max-width:768px)': {
                        flexDirection: 'column',
                      },
                    })
                  }
                >

                  <TextField
                    label="Nom de la classe"
                    onChange={(e) => searchKeyword(e)}
                    size="small"
                    variant="outlined"
                    endAdornment={<Search style={{ color: '#5D75A8' }} />}
                    borderRadius={400}
                  />

                  <Button
                    className={css({
                      color: '#5D75A8',
                      // width: '100%',
                      backgroundColor: '#F3F7FF',
                      border: '1px solid #C0D9FF',
                      fontWeight: 500,
                      display: 'flex',
                      justifyContent: 'start',
                      '&:hover': { border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF' },
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '13.500px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '13.5000px',
                      },
                    })}
                    color="primary"
                    variant="outlined"
                    onClick={() => handleFilterCVOpen()}
                  >
                    <Tune
                      style={{ fontSize: '25px', marginRight: spacing(1), color: '#5D75A8' }}
                    />
                    <FormattedMessage id="filter" />
                  </Button>

                  <Button
                    className={css({
                      color: '#5D75A8',
                      // width: '100%',
                      backgroundColor: '#F3F7FF',
                      border: '1px solid #C0D9FF',
                      fontWeight: 500,
                      display: 'flex',
                      justifyContent: 'space-between',
                      '&:hover': { border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF' },
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '13.500px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '13.5000px',
                      },
                    })}
                    color="primary"
                    variant="outlined"
                    onClick={goToListInviteStudent}
                  >
                    Historique des invitations <ChevronRight />
                  </Button>

                  <Button
                    className={css({
                      color: '#5D75A8',
                      // width: '100%',
                      backgroundColor: '#F3F7FF',
                      border: '1px solid #C0D9FF',
                      fontWeight: 500,
                      display: 'flex',
                      justifyContent: 'space-between',
                      '&:hover': { border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF' },
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '13.500px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '13.5000px',
                      },
                    })}
                    color="primary"
                    variant="outlined"
                    onClick={goToStudentClassHistorique}
                  >
                    Historique des sorties<ChevronRight />
                  </Button>
                  <Button
                    className={[classes.button, css({
                      display: 'none',
                      '@media (max-width:1497px)': {
                        display: 'flex'
                      },
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '15.00px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '14.00px',
                      },
                      '@media only screen and (max-width:768px)': {
                        flexGrow: 1,
                      },
                    })
                    ]}
                    color="primary"
                    onClick={() => setIsExportModalOpen(true)}
                    variant="outlined"
                    disableElevation
                    style={{
                      border: '1px solid #0060F9',
                      fontWeight: 600,
                      backgroundColor: 'white',
                    }}
                  >
                    <GetApp />Exporter
                  </Button>


                  <Button
                    className={[classes.button, classes.buttonHover, css({
                      display: 'none',
                      '@media (max-width:1497px)': {
                        display: 'block'
                      },
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '15.00px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '14.00px',
                      },
                      '@media only screen and (max-width:768px)': {
                        flexGrow: 1,
                      },
                      backgroundColor: 'rgb(192, 217, 255)!important',
                    })]}
                    color="primary"
                    onClick={handleOpenInviteStudents}
                    variant="outlined"
                    style={{
                      border: '1px solid #0060F9',
                      fontWeight: 600,
                      backgroundColor: 'white',
                    }}
                  >
                    <FormattedMessage id="school.classes.research.invitButton" />
                  </Button>

                  <Button
                    className={[classes.button, css({
                      display: 'none',
                      '@media (max-width:1497px)': {
                        display: 'block'
                      },
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '15.00px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '14.00px',
                      },
                      '@media only screen and (max-width:768px)': {
                        flexGrow: 1,
                      },
                    })
                    ]}
                    color="primary"
                    onClick={handleOpenCreateClasses}
                    variant="contained"
                    disableElevation
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    <FormattedMessage id="school.classes.research.newClassButton" />
                  </Button>
                </div>
                <div className={
                  css({
                    display: 'flex',
                    '@media (max-width:1497px)': {
                      display: 'none'
                    },
                    gap: spacing(2),
                    '@media (max-width:768px)': {
                      width: '100%',
                      backgroundColor: 'red'
                    },
                    '@media (max-width:768px)': {
                      flexDirection: 'column',
                    },
                  })
                }
                >
                  <Button
                    className={[classes.button, css({
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '15.00px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '14.00px',
                      },
                      '@media only screen and (max-width:768px)': {
                        flexGrow: 1,
                      },
                    })
                    ]}
                    color="primary"
                    onClick={() => setIsExportModalOpen(true)}
                    variant="outlined"
                    disableElevation
                    style={{
                      border: '1px solid #0060F9',
                      fontWeight: 600,
                      backgroundColor: 'white',
                    }}
                  >
                    <GetApp />Exporter
                  </Button>


                  <Button
                    className={[classes.button, classes.buttonHover, css({
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '15.00px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '14.00px',
                      },
                      '@media only screen and (max-width:768px)': {
                        flexGrow: 1,
                      },
                      backgroundColor: 'rgb(192, 217, 255)!important',
                    })]}
                    color="primary"
                    onClick={handleOpenInviteStudents}
                    variant="outlined"
                    style={{
                      border: '1px solid #0060F9',
                      fontWeight: 600,
                      backgroundColor: 'white',
                    }}
                  >
                    <FormattedMessage id="school.classes.research.invitButton" />
                  </Button>

                  <Button
                    className={[classes.button, css({
                      '@media only screen and (max-width:1920px)': {
                        fontSize: '15.00px',
                      },
                      '@media only screen and (max-width:1600px)': {
                        fontSize: '14.00px',
                      },
                      '@media only screen and (max-width:768px)': {
                        flexGrow: 1,
                      },
                    })
                    ]}
                    color="primary"
                    onClick={handleOpenCreateClasses}
                    variant="contained"
                    disableElevation
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    <FormattedMessage id="school.classes.research.newClassButton" />
                  </Button>
                </div>
              </div>
            </div>
            <Grid item xs={12}>
              <Result
                allClasses={allClasses}
                size={size}
                onPaginationChange={handlePaginationChange}
                page={page}
                refetch={refetch}
                totalElements={totalElements}
                handleOpenExportModal={handleOpenExportModal}
                isLoading={isLoading}
              />
            </Grid>
          </TabPanel>

          <TabPanel value="2" index={2}
            className={css({
              background: 'white',
              borderRadius: '0 10px 10px 10px',
              padding: spacing(2.5),
            })}
          >
            <ActivityStatement
              addAbsence={viewAbsence}
              viewCV={viewCV}
            />
          </TabPanel>
        </div>
      </TabContext>


      <Modal
        onCancel={() => setOpenSetPlanning(false)}
        open={openSetPlanning}
        title="Créer le planning de la classe"
      >
        <div className={classes.modalCreateClasseContainer}>
          <div className={classes.textContainer}>
            <div className={cx(global.subTitle, classes.subTitle)}>Votre classe a été créée avec succès !</div>
            <div className={cx(global.subTitle, classes.subTitle)}>Vous pouvez maintenant créer le planning de la classe.</div>
          </div>
          <div className={classes.buttonContainer}>
            <Button
              className={css({ borderRadius: '6px' })}
              color="primary"
              onClick={() => {
                handleCloseSetPlanning()
              }}
              variant="outlined"
            >
              Plus tard
            </Button>
            <Button
              className={css({ borderRadius: '6px' })}
              color="primary"
              onClick={() => {
                // IL Y A 2 ?? CAR LA REQUETE EN ENLEVE 1, DONC QUAND ON MET 2, ON A 1
                // C'EST CHELOU MAIS CA MARCHE !
                push(`${ROUTES_PATH.SCHOOL_CLASSES_DETAIL}??planning=true`, { params: { id: idClassCreated } });
              }}
              variant="contained"
            >
              Créer le planning
            </Button>
          </div>
        </div>
      </Modal>
      <AbsenceDeclarationModal
        open={absenceModalOpen}
        student={item?.student}
        classroomId={classroomId}
        onClose={() => setAbsenceModalOpen(false)}
        onConfirm={() => {
          if (currentRefetchAbsenceHours) {
            currentRefetchAbsenceHours(); // Re-fetch uniquement pour l'utilisateur ciblé
          }
        }}
      />
      <Modal
        nbStep={1}
        onCancel={handleCloseCreateClasses}
        open={openCreateClasses}
        step={1}
        title={intl.formatMessage({
          id: 'school.createClasse.title',
        })}
        withStep={false}
      >
        <NewClasses close={handleCloseCreateClasses} refetch={refetch}
          handleOpenSetPlanning={handleOpenSetPlanning} handleSetIdClassCreated={handleSetIdClassCreated}
        />
      </Modal>

      <ModalSideBar
        handleClose={handleCloseViewProfil}
        open={viewProfil}
        title={<ProfilName userId={item?.student?.id} absButton={true} />}
        button={
          item?.classroom?.planning &&
          <Button
            className={css({
              color: '#0060F9',
              // width: '100%',
              backgroundColor: '#F3F7FF',
              border: '1px solid #0060F9',
              fontWeight: 500,
              display: 'flex',
              justifyContent: 'space-between',
              marginRight: '20px',
              '&:hover': {
                border: '1px solid #0060F9', backgroundColor: '#0060F9',
                color: "white",
              },
            })}
            color="primary"
            variant="outlined"
            onClick={() => setAbsenceModalOpen(true)}
          >
            Déclarer une absence
          </Button>
        }
        width="700px"
      >
        <ProfilSidebar id={item?.student?.id} typeOrganism="school" classroomId={classroomId} displayPlanning={true} />
      </ModalSideBar>

      <ModalSideBar
        handleClose={handleFilterCVClose}
        open={filterCVOpened}
        title="Filtres"
        width="400px"
      >
        <FiltersClasses formik={formik} />
      </ModalSideBar>
      <ModalStep
        onCancel={handleCloseInviteStudents}
        open={openInviteStudents}
        title={intl.formatMessage({
          id: 'school.classes.invite.title',
        })}
        withStep={false}
      >
        <InviteStudents close={handleCloseInviteStudents} />
      </ModalStep>

      <ExportModal
        open={isExportModalOpen}
        onClose={handleCloseExportModal}
        classes={allClasses}
        idClass={classroomId}
      />
    </div >
  );
};

const styles = ({ spacing }) => ({
  container: {
    height: '100%',
    padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    lineHeight: '100%',

  },
  containerSearch: {
    background: 'white',
    paddingBottom: "20px",
    borderRadius: '10px 10px 0 0',
    display: "flex",
    justifyContent: "space-between",
  },
  searchContainer: {
    marginTop: spacing(2),
  },
  buttonOutlined: {
    border: '1px solid #0060F9',
    '&:hover': {
      border: '1px solid #0060F9',
      filter: 'brightness(0.9)',
      backgroundColor: '#ffffffe6',
    },
  },
  buttonHover: {
    "&:hover": {
      backgroundColor: "#0060F9!important",
      color: "white!important",
    },
  },
  modalCreateClasseContainer: {
    padding: 20,
  },
  textContainer: {
    paddingBottom: spacing(2),
  },
  subTitle: {
    color: "#5D75A8",
    margin: 6
  },
  buttonContainer: {
    display: "flex",
    alignItems: "center",
    gap: 10
  }
});

export default ClassesSchool;
